import { IconButton, MainButton, Text, Theme, XSign } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';
import { declineCallAtom } from '../atoms';
import { useSetAtom } from 'jotai';
import useTypeTracking from '../../../analytics';

interface DeclineButtonProps {
    isDesktop?: boolean;
    isLarge?: boolean;
}

const DeclineButton: React.FC<DeclineButtonProps> = ({ isDesktop = true, isLarge = true }) => {
    const classes = useStyles({ isLarge });
    const setDeclineCall = useSetAtom(declineCallAtom);
    const { trackClickEvent } = useTypeTracking();

    const declineVideoHandle = () => {
        setDeclineCall();
        trackClickEvent({
            buttonType: 'VIDEO_NOTIFICATIONS',
            subCategory: 'DECLINED_MEETING_REQUEST',
        });
    };

    return (
        <>
            {isDesktop ? (
                <MainButton
                    variant="fill"
                    size="large"
                    className={classes.declineButton}
                    onClick={declineVideoHandle}
                >
                    <Text variant="t60">Decline</Text>
                </MainButton>
            ) : (
                <IconButton
                    icon={XSign}
                    className={classes.iconButton}
                    onClick={declineVideoHandle}
                />
            )}
        </>
    );
};

const useStyles = makeStyles<Theme, { isLarge: boolean }>(
    theme => ({
        declineButton: {
            backgroundColor: 'transparent',
            marginRight: ({ isLarge }) => (isLarge ? 40 : 8),
            lineHeight: 0,
            border: ({ isLarge }) => (isLarge ? 'unset' : `1px solid ${theme.palette.greys[100]}`),
        },
        iconButton: {
            backgroundColor: theme.palette.primary[500],
            mixBlendMode: 'unset',
            width: 32,
            height: 32,
            marginRight: 8,
            [theme.breakpoints.up('sm')]: {
                marginRight: 0,
            },
        },
    }),
    { classNamePrefix: 'video-notifications-decline-button' }
);

export default DeclineButton;
